/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_Tip_3Inputs */

const tr_katalog_desi_page_tip_3 = /** @type {(inputs: Katalog_Desi_Page_Tip_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Düzensiz şekilli ürünlerde en geniş ölçüleri kullanın.`)
};

const en_katalog_desi_page_tip_3 = /** @type {(inputs: Katalog_Desi_Page_Tip_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For irregular items, use the widest dimensions.`)
};

const de_katalog_desi_page_tip_3 = /** @type {(inputs: Katalog_Desi_Page_Tip_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei unregelmäßigen Produkten die größten Maße verwenden.`)
};

const ru_katalog_desi_page_tip_3 = /** @type {(inputs: Katalog_Desi_Page_Tip_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для нестандартных товаров берите наибольшие размеры.`)
};

/**
* | output |
* | --- |
* | "For irregular items, use the widest dimensions." |
*
* @param {Katalog_Desi_Page_Tip_3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_tip_3 = /** @type {((inputs?: Katalog_Desi_Page_Tip_3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_Tip_3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_tip_3(inputs)
	if (locale === "de") return de_katalog_desi_page_tip_3(inputs)
	if (locale === "ru") return ru_katalog_desi_page_tip_3(inputs)
	return tr_katalog_desi_page_tip_3(inputs)
});